namespace TabAurous.CRM {
    export namespace ProductCatalogService {
        export const baseUrl = 'CRM/ProductCatalog';

        export declare function Create(request: Serenity.SaveRequest<ProductCatalogRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductCatalogRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CategoryList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SubCategoryList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductTypeList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BrandList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CollectionList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SuperTypeList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductCatalogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BOMShapeList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<OMS.ProductBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CRM/ProductCatalog/Create",
            Update = "CRM/ProductCatalog/Update",
            Delete = "CRM/ProductCatalog/Delete",
            Retrieve = "CRM/ProductCatalog/Retrieve",
            List = "CRM/ProductCatalog/List",
            CategoryList = "CRM/ProductCatalog/CategoryList",
            SubCategoryList = "CRM/ProductCatalog/SubCategoryList",
            ProductTypeList = "CRM/ProductCatalog/ProductTypeList",
            BrandList = "CRM/ProductCatalog/BrandList",
            CollectionList = "CRM/ProductCatalog/CollectionList",
            SuperTypeList = "CRM/ProductCatalog/SuperTypeList",
            BOMShapeList = "CRM/ProductCatalog/BOMShapeList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CategoryList', 
            'SubCategoryList', 
            'ProductTypeList', 
            'BrandList', 
            'CollectionList', 
            'SuperTypeList', 
            'BOMShapeList'
        ].forEach(x => {
            (<any>ProductCatalogService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
